"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const adjustment_1 = require("services/adjustment");
const planning_types_1 = require("../planning.types");
const production_types_1 = require("./production.types");
const getDataGridProduction = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridProduction)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        console.log(response.totalOnMonth);
        if (response.data.length > 0) {
            payload.dataGrid = payload.dataGrid.concat(Object.assign(Object.assign({}, response.totalOnMonth), { contractor: 'Total' }));
        }
        dispatch({ type: production_types_1.planningProductionTypes.SET_DATA_GRID_PRODUCTION, payload });
        dispatch({
            type: planning_types_1.adjustmentPlanningTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isLoading: false }
        });
    }
});
const getDataGridHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridHistoryProduction)(dataStatesHistory);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGridHistory: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { uploaded_at: new Date(item.uploaded_at) });
            })
        };
        dispatch({ type: production_types_1.planningProductionTypes.SET_DATA_GRID_HISTORY, payload });
    }
});
const getLastSucceedUpload = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridHistoryProduction)(dataStatesHistory);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            lastUpdated: response.data.length > 0 ? response.data[0].uploaded_at : null,
        };
        dispatch({ type: production_types_1.planningProductionTypes.SET_LAST_SUCCEED_UPLOAD, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: production_types_1.planningProductionTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: production_types_1.planningProductionTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: production_types_1.planningProductionTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: production_types_1.planningProductionTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: production_types_1.planningProductionTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onSortChangeHistory = payload => dispatch => {
    dispatch({ type: production_types_1.planningProductionTypes.ON_SORT_CHANGE_HISTORY, payload });
};
const onFilterChangeHistory = payload => dispatch => {
    dispatch({ type: production_types_1.planningProductionTypes.ON_FILTER_CHANGE_HISTORY, payload });
};
const onDataStateChangeHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: production_types_1.planningProductionTypes.ON_PAGE_CHANGE_HISTORY, payload: { dataStatesHistory } });
});
const onUploadDocumentTranshipment = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { formdata, filename, year } = payload;
    const responseUpload = yield (0, adjustment_1._uploadDocumentProduction)(formdata);
    const responseProcess = yield (0, adjustment_1._uploadProcessProduction)({ filename, year });
    if (responseUpload.isError || responseProcess.isError) {
        const payload = {
            isError: responseUpload.isError || responseProcess.isError,
            errorCode: responseUpload.errorCode || responseProcess.errorCode,
            errorMessage: responseUpload.errorMessage || responseProcess.errorMessage,
        };
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload });
        dispatch({ type: production_types_1.planningProductionTypes.SET_ERROR, payload });
    }
    else {
        dispatch({
            type: production_types_1.planningProductionTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, selectedYear: year, isLoadingUpload: false }
        });
        dispatch({
            type: planning_types_1.adjustmentPlanningTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: false, isSuccess: true, isLoading: true }
        });
    }
});
const onDownloadTemplateDocument = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._downloadTemplateProduction)(payload);
    if (response.isError) {
        dispatch({ type: planning_types_1.adjustmentPlanningTypes.SET_ERROR, payload: response });
        dispatch({ type: production_types_1.planningProductionTypes.SET_ERROR, payload: response });
    }
    else {
        window.location.href = response.url;
        dispatch({
            type: production_types_1.planningProductionTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: payload.mutationMode, isLoadingDownload: false }
        });
    }
});
exports.default = {
    onSortChange,
    onCloseError,
    onFilterChange,
    onClickMutation,
    onDataStateChange,
    getDataGridHistory,
    onSortChangeHistory,
    getLastSucceedUpload,
    onFilterChangeHistory,
    getDataGridProduction,
    onDataStateChangeHistory,
    onDownloadTemplateDocument,
    onUploadDocumentTranshipment,
};
